import Effect from '@/roc/effects/Effect';
import EffectMechanic from '@/roc/effects/EffectMechanic';
class CultureBonus extends Effect {
    __amount;
    __range;
    constructor(amount, range) {
        super(EffectMechanic.CULTURE_BONUS);
        this.__amount = amount;
        this.__range = range;
    }
    getBonus(level, era) {
        return {
            value: this.__amount.calculate(level, era),
            range: this.__range.calculate(level, era),
        };
    }
    clone(amount = null, range = null) {
        return new CultureBonus(amount || this.__amount, range || this.__range);
    }
    formatDescription(level, era) {
        const am = this.__amount.calculate(level, era);
        if (!am) {
            return null;
        }
        return 'Provide ' + am + ' culture';
    }
}
export default CultureBonus;
